<template>
    <v-card class="card" :title="title">
        <v-checkbox if v-if="filter.values.length > 4" color="primary" hide-details :model-value="all" :label="$tr('Все')"
            :indeterminate="(filter.values.length != selected.length) &&(selected.length != 0)" @click="allClicked"></v-checkbox>
        <v-checkbox v-for="value in filter.values" :key="value.value" color="primary" hide-details v-model="selected"
            :label="value?.label || value" :value="value?.value || value"></v-checkbox>
    </v-card>
</template>

<script>
export default {
    name: 'EnumFilter',
    props: {
        title: {
            type: String,
            default: undefined,
        },
        filter: {
            selected: [],
            values: [],
        },
        isActive: undefined,
    },
    data() {
        return {
            selected: [],
            all: false,
        };
    },
    methods: {
        submit() {
            // eslint-disable-next-line
            this.filter.selected = this.selected;
            this.$emit('submit');
        },
        allClicked() {
            if (this.selected.length === this.filter.values.length) {
                this.selected = [];
            } else {
                const selected = [];
                for (let i = 0; i < this.filter.values.length; i += 1) {
                    selected.push(this.filter.values[i].value || this.filter.values[i]);
                }
                if (this.selected.length !== selected.length) {
                    this.selected = selected;
                }
            }
        },
    },
    computed: {
        active() {
            return this.isActive.value;
        },
    },
    watch: {
        active(value) {
            if (!value) {
                this.submit();
            }
        },
        selected(value) {
            if (value.length === this.filter.values.length) {
                if (!this.all) {
                    this.all = true;
                }
            } else if (this.all) {
                this.all = false;
            }
        },
    },
    mounted() {
        for (let i = 0; i < this.filter.selected.length; i += 1) {
            this.selected.push(this.filter.selected[i]);
        }
        if (this.selected.length === this.filter.values.length) {
            this.all = true;
        }
    },
};
</script>

<style scoped>
.card {
    min-width:200px;
    padding:12px;
}
</style>
